import { Record } from 'immutable';
import _ from 'lodash';

export interface Deed {
  id: string;
  name: string;
  type: string;
}

const properties = {
  id: '',
  deed: undefined,
  status: '',
  duration: 0,
  requestedAt: undefined,
  user: '',
  startingAt: undefined,
  endingAt: undefined,
};

export default class VolunteerTimeOff
  extends Record(properties, 'VolunteerTimeOff')
  implements VolunteerTimeOff
{
  public readonly id!: string;

  public readonly deed!: Deed;

  public readonly status!: 'REQUESTED' | 'APPROVED' | 'DECLINED' | 'CANCELLED' | 'DELETED';

  public readonly duration!: number;

  public readonly requestedAt!: Date;

  public readonly user!: string;

  public readonly startingAt!: Date;

  public readonly endingAt!: Date;

  constructor(values: any = {}) {
    const validValues = _.pick(values, Object.keys(properties));
    super({
      ...validValues,
      id: values._id || values.id,
      requestedAt: new Date(values.requestedAt),
      startingAt: new Date(values.startingAt),
      endingAt: new Date(values.endingAt),
      // @FIXME-AS: this is temporary solution until we define new data modeling
      deed: values.deed || values.Deed,
    });
  }
}
